import { render, staticRenderFns } from "./LegendsPastTest.vue?vue&type=template&id=74688d42&"
import script from "./LegendsPastTest.vue?vue&type=script&lang=js&"
export * from "./LegendsPastTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports